import React, { Suspense, lazy, useEffect, useState } from "react";
import useFetch from "../../utils/useFetch";
import SitemapData from "./sitemap.json"
const Sitemap = lazy(() => import("./Sitemap/Sitemap"));
const Footer = lazy(() => import("../../components/Footer"));

const SitemapHome = () => {

    const jsonPath = process.env.REACT_APP_CDN + "eaimortgage/jsons/eaimortgage-sitemap.json"
    // const data = SitemapData
      const data = useFetch(jsonPath);
    const [showOtherComponents, setShowOtherComponents] = useState(false);


    const handleScroll = () => {
        const windowHeight = window.innerHeight;
        const documentHeight = document.body.offsetHeight;
        const scrollPosition =
            window.scrollY ||
            window.pageYOffset ||
            document.documentElement.scrollTop;
        const maxScroll = documentHeight - windowHeight;
        const percentage = (scrollPosition / maxScroll) * 100;

        if (percentage > 0) {
            setShowOtherComponents(true);
        }
    };
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        if (showOtherComponents) {
            window.removeEventListener("scroll", handleScroll);
        }
    }, [showOtherComponents]);

    if (data === null) {
        return (<div />)
    }

    return (
        <>
            <Suspense fallback={<div />}>
                <Sitemap sitemapData={data} />
            </Suspense>
            {showOtherComponents && (
                <>
                    {/* <Suspense fallback={<div />}>
                        <Footer />
                    </Suspense> */}
                </>
            )}
        </>
    )
}

export default SitemapHome;